import { useMutation } from '@tanstack/react-query';
import post2faEMAILApiCall from '../../api/calls/post2faEMAILApiCall';

const useSend2faEMAILMutation = () => useMutation(post2faEMAILApiCall);

export default useSend2faEMAILMutation;
